var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLobby(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lobby_white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.971,
    height: 93.971,
    viewBox: "0 0 93.971 93.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f5f5f5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-1",
    d: "M217.456,348.3a2.249,2.249,0,1,0,1.589-.658A2.249,2.249,0,0,0,217.456,348.3Z",
    transform: "translate(-176.425 -282.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-1",
    d: "M439.725,393.55a2.252,2.252,0,1,0,1.589.661A2.252,2.252,0,0,0,439.725,393.55Z",
    transform: "translate(-357.894 -320.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-1",
    d: "M92.134,48.821H84.053v-15.4a9.209,9.209,0,0,0-7.185-8.94l-6-1.316a9.606,9.606,0,0,0,3.368-7.305V9.628a9.628,9.628,0,1,0-19.256,0v6.236a9.6,9.6,0,0,0,3.363,7.3l-6,1.315a9.209,9.209,0,0,0-7.191,8.94v8.059H35.239A1.838,1.838,0,0,0,33.4,43.315v5.507H20.557v-5.14h7.706A1.836,1.836,0,0,0,30.1,41.847V22.025a1.836,1.836,0,0,0-1.836-1.836H1.836A1.834,1.834,0,0,0,0,22.025V41.847a1.834,1.834,0,0,0,1.836,1.834H9.542v5.14H1.836A1.834,1.834,0,0,0,0,50.656v8.811A1.834,1.834,0,0,0,1.836,61.3H8.081V92.134A1.834,1.834,0,0,0,9.91,93.971H84.06a1.834,1.834,0,0,0,1.834-1.836V83.141a1.836,1.836,0,0,0-3.67,0V90.3H11.746V69.006H35.239a1.836,1.836,0,1,0,0-3.67H11.746V61.3H82.224v7.159a1.836,1.836,0,0,0,3.67,0V61.3h6.24a1.834,1.834,0,0,0,1.836-1.834V50.656a1.834,1.834,0,0,0-1.836-1.834ZM58.647,14.564h2.526a16.883,16.883,0,0,0,9.4-2.819v4.12a5.958,5.958,0,1,1-11.915,0ZM64.6,25.492a9.634,9.634,0,0,0,1.675-.148l-1.691,3.823-1.7-3.832A9.653,9.653,0,0,0,64.6,25.492Zm0-21.822A5.967,5.967,0,0,1,70.14,7.429,13.239,13.239,0,0,1,61.173,10.9H58.647V9.628A5.965,5.965,0,0,1,64.6,3.67ZM48.818,33.42a5.512,5.512,0,0,1,4.306-5.354l6.334-1.389L62.9,34.433a1.836,1.836,0,0,0,3.355,0L69.7,26.674l6.373,1.395a5.51,5.51,0,0,1,4.309,5.354v15.4H60.568V43.315a1.838,1.838,0,0,0-1.836-1.836h-9.91ZM37.071,45.149H56.9v3.672H37.075ZM3.67,23.869H26.428V40.02h-5.9a5.507,5.507,0,0,0-10.955,0H3.67ZM13.214,40.6a1.836,1.836,0,1,1,3.67,0V48.84h-3.67ZM90.3,57.649H3.67V52.492H90.3Z",
    transform: "translate(0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLobby);
export default __webpack_public_path__ + "static/media/Lobby.1d4bd277f8a52028f563a3169b400a1b.svg";
export { ForwardRef as ReactComponent };